/* eslint-disable */
'use strict'
const AddToCart = {
    init: function() {
        this.bindEvents();
    },


    bindEvents: function() {
        document.querySelectorAll('form[id^="add-to-cart-form-"]').forEach(function(form) {
            form.addEventListener('submit', function(event) {
                event.preventDefault();

                var productId = form.querySelector('input[name="id"]').value;
                var quantity = form.querySelector('input[name="quantity"]').value;
                var sellingPlan = form.querySelector('input[name="selling_plan"]').value;

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: productId,
                        quantity: quantity,
                        selling_plan: sellingPlan
                    })
                })
                    .then(response => response.json())
                    .then((data) => {
                        // if(fbq && data.id) {
                        //     const subscription = data.selling_plan_allocation;
                        //     let subscriptionData = !!subscription ? {
                        //         subscription_id: !!subscription && subscription.selling_plan.id,
                        //         subscription_name: !!subscription && subscription.selling_plan.name,
                        //         subscription_discount_value: !!subscription && subscription.selling_plan.price_adjustments[0].value,
                        //         subscription_discount_type: !!subscription && subscription.selling_plan.price_adjustments[0].value_type,
                        //     } : {};
                        //     let fbqData = {
                        //         content_type: 'product',
                        //         currency: (Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
                        //         value: data.presentment_price,
                        //         contents: [{
                        //             id: `${data.product_id}`,
                        //             quantity: +quantity || 1,
                        //             product_title: data.product_title,
                        //             product_type: data.product_type || '',
                        //             price: data.presentment_price,
                        //             variant_id: data.variant_id,
                        //             variant_title: data.variant_title,
                        //             sku: data.sku,
                        //             subscription: !!subscription,
                        //         }]
                        //     };
                        //
                        //     fbqData.contents[0] = Object.assign(fbqData.contents[0], subscriptionData);
                        //
                        //     fbq('track', 'AddToCart', fbqData);
                        // }

                        if (typeof Rebuy == 'undefined' && !Rebuy.Cart) {
                            window.location.assign('/checkout');
                        }
                    })
                    .catch(error => {
                        console.error('Error adding product to cart:', error);
                    });
            });
        });
    }
}

export default AddToCart; 